$(document).ready(function () {
	try{
		$(":input[name='cpf']").mask("999.999.999-99");
		$(":input[name='postcode']").mask("99999-999");
		$(":input[name='dt_nascto']").mask("99/99/9999");
		$(":input[name='telephone']").mask("(99) 99999-9999");
	}catch(e){
	}	
});